import { render, staticRenderFns } from "./gedaechniswasser.vue?vue&type=template&id=4622d87a&scoped=true&"
import script from "./gedaechniswasser.vue?vue&type=script&lang=js&"
export * from "./gedaechniswasser.vue?vue&type=script&lang=js&"
import style0 from "./gedaechniswasser.vue?vue&type=style&index=0&id=4622d87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622d87a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
